import { render, staticRenderFns } from "./shopAftersaleTemplate.vue?vue&type=template&id=53198b61&"
import script from "./shopAftersaleTemplate.vue?vue&type=script&lang=js&"
export * from "./shopAftersaleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports